;(function () {
  'use strict'

  angular
    .module('contrast.settings.user.tsv')
    .factory('tsvCodesDownloader', tsvCodesDownloaderFactory)

  function tsvCodesDownloaderFactory(FileSaver, Blob) {
    'ngInject'

    var service = {
      download: download
    }

    return service

    function download(codes) {
      var codesTxt = _buildCodesTxt(codes)
      _downloadCodes(codesTxt)
    }

    function _buildCodesTxt(codes) {
      var codesTxt = ''
      angular.forEach(codes, function (code) {
        codes = codes + code + '<br/>'
        codesTxt = codesTxt + code + '\r\n'
      })
      return codesTxt
    }

    function _downloadCodes(codesTxt) {
      var data = new Blob([codesTxt], { type: 'text/plain;charset=utf-8' })
      var date = new Date().toISOString().slice(0, 10).replace(/-/g, '')
      FileSaver.saveAs(data, date + '-backup-codes.txt', true)
    }
  }
})()
